import { changeProcessUponDeliveryModal } from 'shared/helpers/constants/modalConstants';

function changeProcessUponDeliveryModalData(value) {
  const { doNotProcess, processUponDelivery } = changeProcessUponDeliveryModal;

  return value ? doNotProcess : processUponDelivery;
}

export { changeProcessUponDeliveryModalData };
